/**
 * Web App Component
 * PWA Entry Point - Uses react-router-dom (NOT @react-navigation/native)
 */

import React from 'react';
import { View, StyleSheet } from 'react-native';

// Web Router (react-router-dom)
import WebRouter from './src/navigation/WebRouter';

// Context Providers
import { ThemeProvider, useTheme } from './src/context/ThemeContext';
import { AppProvider } from './src/context/AppContext';

const AppContent = () => {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors?.background || '#1a1a2e' }]}>
      <WebRouter />
    </View>
  );
};

const App = () => {
  return (
    <AppProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AppProvider>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    maxHeight: '100vh',
    maxHeight: '100dvh', // Dynamic viewport height for mobile
    overflow: 'hidden',
    position: 'relative',
  },
});

export default App;